import EmailPulseSummaryCards from '../email-pulse-summary-cards/email-pulse-summary-cards.component';
import { overviewSummaryCardsConfig } from './overview.config';

/**
 * Overview tab summary cards component.
 * Wrapper around the generic EmailPulseSummaryCards with Overview-specific configuration.
 */
const OverviewSummaryCards = () => {
  return <EmailPulseSummaryCards config={overviewSummaryCardsConfig} />;
};

export default OverviewSummaryCards;
